import { programShowcase, showcaseTagline } from "@/mocks/programShowcase";
import { useTranslatedList, useTranslatedRecord } from "@/hooks/useTranslatedList";

export default function ProgramsShowcaseSection() {
  const tagline = useTranslatedRecord(showcaseTagline, ["subtitle", "title", "intro"]);
  const showcase = useTranslatedList(programShowcase, ["title", "description"]);
  return (
    <section className="bg-primary-900 py-14 md:py-20 text-white">
      <div className="ltv-container">
        {/* Tagline header */}
        <div className="max-w-3xl mx-auto text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-2 text-accent-400 text-xs md:text-sm font-semibold uppercase tracking-widest mb-3">
            <i className="ri-tv-line" />
            {tagline.subtitle}
          </span>
          <h2 className="text-2xl md:text-4xl font-bold leading-tight">
            {tagline.title}
          </h2>
          <p className="mt-4 text-white/70 text-sm md:text-base leading-relaxed">
            {tagline.intro}
          </p>
        </div>

        {/* Programs grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {showcase.map((p) => (
            <div
              key={p.id}
              className="bg-white/5 hover:bg-white/10 border border-white/10 rounded-lg p-5 transition-colors group"
            >
              <span
                className={`w-12 h-12 flex items-center justify-center rounded-md bg-gradient-to-br ${p.accent} text-white text-xl mb-4`}
              >
                <i className={`${p.icon} text-2xl`} />
              </span>
              <h3 className="text-sm md:text-base font-bold leading-snug text-white">
                {p.title}
              </h3>
              <p className="text-[11px] uppercase tracking-wide text-accent-400 mt-1">
                {p.titleEn}
              </p>
              <p className="text-xs text-white/60 mt-2 leading-relaxed">{p.description}</p>
              <div className="mt-4 flex items-center gap-1.5 text-[11px] text-white/50">
                <i className="ri-time-line" />
                <span>{p.schedule}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}